import { useEffect } from 'react'
import { socketSingleton } from 'services/ws'
import { ChatWebSocketMessage, WebsocketActionsEnum } from 'types/index'
import { store } from 'store/index'
import { messagesActions } from 'store/messages'
import { Chat } from 'types/chat'

export const useUserChatListSocket = (currentUserId: string | undefined) => {
  useEffect(() => {
    if (!currentUserId) return

    const onNewMessage = (wsMessage: ChatWebSocketMessage) => {
      if (!wsMessage.body?.chatId) return
      store.dispatch(
        messagesActions.updateChat({
          lastMessage: wsMessage.body,
          _id: wsMessage.body.chatId,
        }),
      )
    }

    const onUpdateParticipants = (wsMessage: ChatWebSocketMessage) => {
      const updatedChat = wsMessage.body as Chat
      store.dispatch(messagesActions.setChat(updatedChat))
    }

    socketSingleton.join(currentUserId)
    socketSingleton.on(WebsocketActionsEnum.NEW_MESSAGE, onNewMessage)
    socketSingleton.on(WebsocketActionsEnum.UPDATE_CHAT_PARTICIPANTS, onUpdateParticipants)

    return () => {
      socketSingleton.off(WebsocketActionsEnum.NEW_MESSAGE, onNewMessage)
      socketSingleton.off(WebsocketActionsEnum.UPDATE_CHAT_PARTICIPANTS, onUpdateParticipants)
      socketSingleton.leave(currentUserId)
    }
  }, [currentUserId])
}
